import React from 'react';
import styles from './chip.module.scss';
import { BodyText, Icon } from '@placer-ui/components';

type SuggestionChipProps = {
    text: string;
    iconType: string;
    onClick: (text: string) => void;
};
export const Chip = ({ text, iconType, onClick }: SuggestionChipProps) => {
    return (
        <button
            onClick={() => onClick(text)}
            className={styles.container}
            aria-label={`Chip Suggestion: ${text}`}
            type="button"
            data-testid={`chip-${text}`}
            data-icon-type={iconType}
        >
            <Icon.IconContainer
                size="small"
                color="brand"
                shape="square"
                borderRadius="xl"
                testId="chip-button"
            >
                <Icon type={iconType} size={18} color="brand" />
            </Icon.IconContainer>
            <BodyText variant={'semi-bold'}>{text}</BodyText>
        </button>
    );
};
